import React from "react";
import { Link } from "react-router-dom";
import { useSnapshot } from "valtio";

import { store as userStore } from "@components/VerticalLayout/store";
import { useSelector } from "react-redux";

export type CardMenuType = {
    Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    description?: string;
    title: string;
    path: string;
    setIsModalOpened: Function;
};

export default function CardMenu({
    title,
    Icon,
    description,
    path,
    setIsModalOpened,
}: CardMenuType) {
    const [Survol, setSurvol] = React.useState<boolean>(false);
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const { isDefault } = useSnapshot(userStore);
    return (
        <div
            className=" page-card-carte col-lg-4 col-xl-4 col-md-6 col-sm-12 col-xs-12 my-2"
            style={{
                cursor: "pointer",
            }}
            onMouseEnter={() => {
                setSurvol(true);
            }}
            onMouseLeave={() => {
                setSurvol(false);
            }}
        >
            {isDefault ? (
                <Link to={path}>
                    <div
                        className="card  h-100 float-right"
                        style={{
                            padding: "1em",
                            borderRadius: "12px",
                            backgroundColor: Survol ? mainColor : "",
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: 0,
                        }}
                    >
                        <div className="row align-items-center">
                            <div className="col-lg-12 col-xl-4 col-md-12 col-sm-12 col-xs-12 d-flex align-items-center justify-content-center">
                                <div>
                                    {Survol ? (
                                        <Icon
                                            className="d-block w-100 "
                                            fill={mainColor}
                                            stopColor="#FFFFFF"
                                        />
                                    ) : (
                                        <Icon
                                            fill="#FFFFFF"
                                            stopColor={mainColor}
                                            className="d-block w-100"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-8 col-md-12 col-sm-12 col-xs-12 ">
                                <div className="card-block">
                                    <div className="d-flex flex-column pl-1">
                                        <div
                                            className="d-flex justify-content-between card-title"
                                            style={{
                                                color: "rgb(41, 41, 41)",
                                                letterSpacing: "1.4px",
                                            }}
                                        >
                                            <strong>{title}</strong>
                                        </div>

                                        <p
                                            style={{
                                                color: "rgb(33, 39, 57)",
                                            }}
                                            className="card-text"
                                        >
                                            {description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            ) : (
                <div
                    className="card  h-100 float-right"
                    style={{
                        padding: "1em",
                        borderRadius: "12px",
                        backgroundColor: Survol ? mainColor : "",
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: 0,
                    }}
                    onClick={() => {
                        setIsModalOpened(true);
                    }}
                >
                    <div className="row align-items-center">
                        <div className="col-lg-12 col-xl-4 col-md-12 col-sm-12 col-xs-12 d-flex align-items-center justify-content-center">
                            <div>
                                {Survol ? (
                                    <Icon
                                        className="d-block w-100 "
                                        fill={mainColor}
                                        stopColor="#FFFFFF"
                                    />
                                ) : (
                                    <Icon
                                        fill="#FFFFFF"
                                        stopColor={mainColor}
                                        className="d-block w-100"
                                    />
                                )}
                            </div>
                        </div>
                        <div className="col-lg-12 col-xl-8 col-md-12 col-sm-12 col-xs-12 ">
                            <div className="card-block">
                                <div className="d-flex flex-column pl-1">
                                    <div
                                        className="d-flex justify-content-between card-title"
                                        style={{
                                            color: "rgb(41, 41, 41)",
                                            letterSpacing: "1.4px",
                                        }}
                                    >
                                        <strong>{title}</strong>
                                    </div>

                                    <p
                                        style={{
                                            color: "rgb(33, 39, 57)",
                                        }}
                                        className="card-text"
                                    >
                                        {description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
